import { todayIsoInZone } from '@harvus/shared';
// Build a hierarchical deal options list for Select dropdowns.
// Parents first (no indent), children indented beneath their parent.
// Pass required=true to show "— Select a deal —" instead of "— No deal —".
export const buildDealOptions = (deals = [], { required = false } = {}) => {
  const placeholder = required ? "— Select a deal (required) —" : "— No deal —";
  if (!deals.length) return [{ value: "", label: "— No deals exist yet —" }];
  const opts = [{ value: "", label: placeholder }];
  // Deals are already sorted by SortPath from the API (tree order)
  for (const p of deals) {
    const depth = p.depth || 0;
    const indent = "  ".repeat(depth);
    const prefix = depth > 0 ? "↳ " : "";
    opts.push({ value: p.dealID, label: `${indent}${prefix}${p.name}` });
  }
  return opts;
};


// The person's today (saved zone), not the UTC date — which is tomorrow by evening.
export const todayISO = () => todayIsoInZone();


// Detect whether a free-text search string is a pair of lat/long coordinates.
// Accepts "lat, lng" or "lat lng" with an optional comma, an optional degree
// sign, and optional N/S/E/W hemisphere suffixes (e.g. "32.7767 N, 96.797 W").
// Returns { lat, lng } when the string is a valid coordinate pair (lat in
// [-90, 90], lng in [-180, 180]) or null otherwise, so callers can route a
// coordinate search to the point lookup instead of the address search.
export const parseLatLng = (raw) => {
  if (!raw) return null;
  const s = String(raw).trim();

  // One signed decimal number followed by an optional hemisphere letter.
  const num = "([+-]?\\d+(?:\\.\\d+)?)\\s*[°]?\\s*([NnSsEeWw])?";
  const m = s.match(new RegExp(`^${num}\\s*[, ]\\s*${num}$`));
  if (!m) return null;

  const applyHemisphere = (value, letter) => {
    if (!letter) return value;
    const up = letter.toUpperCase();
    const magnitude = Math.abs(value);
    return up === "S" || up === "W" ? -magnitude : magnitude;
  };

  const lat = applyHemisphere(parseFloat(m[1]), m[2]);
  const lng = applyHemisphere(parseFloat(m[3]), m[4]);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;

  return { lat, lng };
};
